import { Component, OnInit, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'cake-total-stk',
  templateUrl: './cake-total-stk.component.html',
  styleUrls: ['./cake-total-stk.component.scss']
})
export class CakeTotalStkComponent implements OnInit {
  @Input() quantity: number;
  @Input() price: number;
  @Input() currency: string;

  constructor() { }

  ngOnInit() {
  }

}
